module.exports = __webpack_public_path__ + "db0c0572effc518ef22011023d228fa5.MP3";